import React, { useRef } from "react";
import styled from "styled-components";

import { Text } from "@examspark/common-ui";
import { useJumpBar } from "@examspark/common-ui/dist/components/utils/JumpBar";

const StyledContentSection = styled.section`
  display: flex;
  flex-direction: column;

  gap: 1rem;

  counter-reset: section;

  // this is hardcoded to match the height of the sticky header
  scroll-margin-top: 9.3rem;
`;

const ContentSectionTitle = styled(Text.H2)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;
const ContentSectionSubtitle = ContentSectionTitle.withComponent(Text.H3);

const ContentSectionTitleBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ContentSectionAction = styled.div`
  place-self: flex-end;
`;

type ContentSectionProps = {
  title: string;
  header?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
};

const ContentSection = ({
  title,
  header,
  children,
  actions,
  className,
}: ContentSectionProps) => {
  const ref = useRef<HTMLElement>(null);
  useJumpBar({ label: title, ref, isSubsection: false });

  // the tabIndex lets us focus the text for screen readers
  return (
    <StyledContentSection ref={ref} className={className} tabIndex={-1}>
      <ContentSectionTitleBar>
        <ContentSectionTitle>{header ?? title}</ContentSectionTitle>
        {actions && <ContentSectionAction>{actions}</ContentSectionAction>}
      </ContentSectionTitleBar>
      {children}
    </StyledContentSection>
  );
};

export const ContentSectionSecondary = ({
  title,
  header,
  children,
  actions,
  className,
}: ContentSectionProps) => {
  const ref = useRef<HTMLElement>(null);

  // the tabIndex lets us focus the text for screen readers
  return (
    <StyledContentSection ref={ref} className={className}>
      <ContentSectionTitleBar>
        <ContentSectionSubtitle> {header ?? title} </ContentSectionSubtitle>
        {actions && <ContentSectionAction>{actions}</ContentSectionAction>}
      </ContentSectionTitleBar>
      {children}
    </StyledContentSection>
  );
};

export default ContentSection;
